import { createContext, useContext, useMemo } from 'react';

type QuoteLineContextType = {
  quoteLineUuid: string;
};

const QuoteLineContext = createContext<QuoteLineContextType | null>(null);

type QuoteLineProviderProps = QuoteLineContextType & {
  children: React.ReactNode;
};

export function QuoteLineProvider({
  quoteLineUuid,
  children,
}: QuoteLineProviderProps) {
  return (
    <QuoteLineContext.Provider
      value={useMemo(() => ({ quoteLineUuid }), [quoteLineUuid])}
    >
      {children}
    </QuoteLineContext.Provider>
  );
}

export function useQuoteLineContext() {
  const context = useContext(QuoteLineContext);

  if (!context) {
    throw new Error(
      'useQuoteLineContext must be used within a QuoteLineProvider',
    );
  }

  return context;
}
